import NotifyAPI from '@/apis/business/common/notify-api.js'
import { HttpStatusCode } from '@/common/constant'

export default {
  namespaced: true,

  state: {
    numberNotifyUnPreview: 0,
    notifies: [],
    platformNotify: null
  },

  getters: {},

  mutations: {
    /**
     * @description reset dữ liệu thông báo
     * @author VDDung1
     * @param {*} state
     */
    clearNotifies (state) {
      state.notifies = []
    },

    /**
     * @author PVThang
     * @description set giá trị cho numberNotifyUnPreview
     * @param {*} state
     * @param {Number} newValue
     */
    setNumberNotifyUnPreview (state, newValue) {
      state.numberNotifyUnPreview = newValue > 0 ? newValue : 0
    },

    /**
     * @author PVThang
     * @description set giá trị cho listNotify
     * @param {*} state
     * @param {Array} newList
     */
    setNotifies (state, newList) {
      state.notifies = newList || []
    },

    /**
     * @author PVThang
     * @description Đánh dấu các notify là đã đọc
     * @param {*} state
     * @param {*} listKeyGroup
     */
    setIsReadNotify (state, listKeyGroup) {
      if (!Array.isArray(listKeyGroup)) {
        listKeyGroup = [listKeyGroup.toString()]
      }

      state.notifies?.forEach((notify) => {
        if (listKeyGroup.includes(notify.KeyGroup)) {
          notify.IsRead = true
        }
      })
    },
    /**
     * @author lhlong
     * @description show thông báo nhận được từ platform
     * @param {*} state
     * @param {*} listKeyGroup
     */
    setPlatformNotify (state, platformNotify) {
      state.platformNotify = platformNotify
    }
  },

  actions: {
    /**
     * @author PVThang
     * @description Lấy danh sách thông báo
     * @param {*} context
     */
    async getNotify (context, filter) {
      const queryFilter = `?page=${filter.PageIndex || 1}&limit=${
        filter.PageSize
      }`
      const res = await NotifyAPI.getAsync(queryFilter)

      context.commit('setNotifies', [
        ...context.state.notifies,
        ...(res?.Data?.PageData || [])
      ])
      filter.IsSetNumberUnPreview &&
        context.commit('setNumberNotifyUnPreview', res?.Data?.Total)
      return res?.Data?.PageData
    },

    /**
     * @author PVThang
     * @description Đếm số lượng thông báo chưa preview
     * @param {*} context
     */
    async countNotifyUnPreview (context, params) {
      const res = await NotifyAPI.getAsync('unpreview/count', { params })
      context.commit('setNumberNotifyUnPreview', res?.Data?.TotalUnpreview)
      context.commit('setPlatformNotify', res?.Data?.Notify)
      if (res) {
        return res
      }
    },

    /**
     * @author PVThang
     * @description Preview các thông báo
     * @param {*} context
     * @returns
     */
    previewNotify (context, isSetNumberUnPreview = false) {
      isSetNumberUnPreview && context.commit('setNumberNotifyUnPreview', 0)
      return NotifyAPI.putAsync('preview')
    },

    /**
     * @author PVThang
     * @description đánh dấu thông báo đã đọc
     * @param {*} context
     * @param {*} params
     * @returns
     */
    readNotify (context, params) {
      if (!Array.isArray(params)) {
        params = [params.toString()]
      }
      context.commit('setIsReadNotify', params)
      return NotifyAPI.putAsync('read', params)
    },

    /**
     * @author lhlong
     * @description đánh dấu thông báo platform đã đọc
     * @param {*} context
     * @param {*} params
     * @returns
     */
    insertPlaformNotify (context, params) {
      return NotifyAPI.postAsync('insert-external-notify', params)
    },

    /**
     * @author lhlong
     * @description đánh dấu thông báo đã đọc
     * @param {*} context
     * @param {*} params
     * @returns
     */
    updateIsReadNotify (context, params) {
      return NotifyAPI.patchAsync('update-is-read-notify', params)
    },

    /**
     * @author lhlong
     * @description lấy content thông báo từ bên ISMAC
     * @param {*} context
     * @param {*} params
     * @returns
     */
    getContentForISMACNotify (context, params) {
      return new Promise((resolve, reject) => {
        NotifyAPI.getAsync('get-ismac-content', { params })
          .then((res) => {
            if (res.Data && res.Code === HttpStatusCode.OK) {
              resolve(res.Data)
            }
          })
          .catch((err) => {
            reject(err)
          })
      })
    }
  }
}
